import gql from 'graphql-tag'

export const getCarriers = gql`
  query($paging: PagingQuery, $order: CarriersOrder, $filter: CarriersFilter!) {
    getCarriers(
      filter: $filter,
      order: $order,
      paging: $paging
    ) {
      carriers {
        id
        name
        hoursOfOperation
        policyTypes
        amBestRating
        notes
        website
        username
        password
        producerCode
        directAppointment
        primaryAddressState
        primaryAddressCity
        primaryAddressZipCode
        primaryAddressStreet1
        primaryAddressStreet2
        email
        phone
        countryCode
        countryCallingCode
        extensionNumber
        fax
        faxCountryCode
        faxCountryCallingCode
        faxExtensionNumber
        policyDocumentsDelivery
        downloads
        endorsementDocumentDelivery
        createdAt
        updatedAt
      }
      paging{ totalCount currentOffset currentLimit }
    }
  }
`

export const getCandidateCarriers = gql`
  query($paging: PagingQuery, $filter: CarriersFilter!) {
    getCarriers(
      filter: $filter,
      paging: $paging
    ) {
      carriers {
        id
        name
      }
    }
  }
`

export const getCarrier = gql`
  query($carrierId: Int!) {
    getCarrier(
      carrierId: $carrierId
    ) {
      id
      name
      hoursOfOperation
      policyTypes
      amBestRating
      notes
      website
      username
      password
      producerCode
      directAppointment
      primaryAddressState
      primaryAddressCity
      primaryAddressZipCode
      primaryAddressStreet1
      primaryAddressStreet2
      email
      phone
      countryCode
      countryCallingCode
      extensionNumber
      fax
      faxCountryCode
      faxCountryCallingCode
      faxExtensionNumber
      policyDocumentsDelivery
      downloads
      endorsementDocumentDelivery
      createdAt
      updatedAt
      lastModifiedBy {
        id
        username
      }
      createdBy {
        id
        username
      }
    }
  }
`

export const newCarrier = gql`
  mutation($carrierInput: CarrierInput!) {
    newCarrier(
      carrierInput: $carrierInput
    ) {
      id
    }
  }
`

export const editCarrier = gql`
  mutation($carrierInput: CarrierInput!, $carrierId: Int!) {
    editCarrier(
      carrierInput: $carrierInput,
      carrierId: $carrierId
    ) {
      id
    }
  }
`

export const deleteCarrier = gql`
  mutation($carrierId: Int!) {
    deleteCarrier(
      carrierId: $carrierId
    )
  }
`
